import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OrderCashierVo, OrderCashierQuery, ChannelCustomerSessionVo, ChannelCustomerSessionDTO } from './type';

/**
 * 直接下单收银台
  POST /api/order/buyer/cashier
  接口ID：236224010
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-236224010
 */
export const postCashier = (data: OrderCashierQuery): AxiosPromise<OrderCashierVo> => {
  return request({
    url: '/api/order/buyer/cashier',
    method: 'post',
    data
  });
};

// 获取customerSessionToken
export const getCustomerSessionToken = (params: ChannelCustomerSessionDTO): AxiosPromise<ChannelCustomerSessionVo> => {
  return request({
    url: '/payment/channel/customer/session',
    method: 'get',
    params
  });
};
